/** html2canvas 오프스크린 캡처용 — 기록 모아보기 표 */
export const CLASS_RECORD_MEMOS_CAPTURE_CSS = `
.cp-class-record-memos-export-root {
  display: flex !important;
  flex-direction: column !important;
  gap: 10px !important;
  background: #fff !important;
  overflow: visible !important;
  max-height: none !important;
}
.cp-class-record-memos-export-meta {
  position: static !important;
  left: auto !important;
  top: auto !important;
  width: 100% !important;
  height: auto !important;
  overflow: visible !important;
  clip: auto !important;
  visibility: visible !important;
  opacity: 1 !important;
  margin: 0 0 4px !important;
  padding: 0 0 6px !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: flex-start !important;
  text-align: center !important;
  color: #111;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Noto Sans KR', sans-serif;
  pointer-events: none !important;
}
.cp-class-record-memos-export-title {
  margin: 0 0 4px;
  width: 100% !important;
  text-align: center !important;
  font-size: 20px !important;
  font-weight: 800;
  line-height: 1.35 !important;
  color: #111;
}
.cp-class-record-memos-export-subtitle {
  margin: 0;
  width: 100% !important;
  text-align: center !important;
  font-size: 14px !important;
  font-weight: 600;
  line-height: 1.35 !important;
  color: #444;
}
.cp-class-record-memos-table-wrap {
  overflow: visible !important;
  max-height: none !important;
  border: 1px solid #cfcfcf !important;
  border-radius: 0 !important;
  background: #fff !important;
}
.cp-class-record-memos-table {
  width: 100% !important;
  min-width: 0 !important;
  max-width: none !important;
  font-size: 11px !important;
  color: #111 !important;
  background: #fff !important;
}
.cp-class-record-memos-table th,
.cp-class-record-memos-table td {
  border: 1px solid #bdbdbd !important;
  background: #fff !important;
  color: #111 !important;
  overflow: visible !important;
  text-overflow: clip !important;
}
.cp-class-record-memos-table thead th {
  background: #f4f4f4 !important;
  font-weight: 700 !important;
}
.cp-class-record-memos-tr-filler,
.cp-class-record-memos-td-filler {
  display: none !important;
}
.cp-class-record-memos-th-btn {
  padding: 4px 6px !important;
  color: #111 !important;
}
.cp-class-record-memos-th-sort-icon {
  display: none !important;
}
.cp-class-record-memos-program-mark--fixed {
  background: #2f6f4f !important;
}
.cp-class-record-memos-program-mark--project {
  background-color: #2f6f4f !important;
}
.cp-class-record-memos-program-mark--track {
  background: #fff !important;
  border: 2px solid #2f6f4f !important;
}
.cp-program-class-rec-inline-lesson,
.cp-program-class-rec-inline-eval_log {
  color: #111 !important;
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
}
`;
